module.exports = __webpack_public_path__ + "static/media/challenge-1.a44b9644.jpg";